var SCM = SCM || {};

(function (ns, headings, iou, $) {

    ns.init = function () {
        headings.init();
        iou.init();
    };

    ns.goToPageHandler = function () {
        $('#goToPageNumberBook, #goToPageNumber').on('click', function () {
            $('.pageError').hide();
            var pageNumber = $('#pageNumberEntry').val();
            if (pageNumber.length) {
                var $page = $(`a[name="page-${pageNumber}"]`);
                // If it's on this page and not a page on the current chaper page, don't need 
                // to find the chapter on the server side
                var $pageMatch = $(`a[name="page-${pageNumber}"]`).closest('#endNotesTargetLocation');

                if (!$pageMatch.length && $page && $page.length) {
                    window.location.hash = `page-${pageNumber}`;
                    $('#pageNumberEntry').val('');
                }
                else {
                    var baseUrl = App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '';
                    $.ajax({
                        url: baseUrl + '/Content/GoToBookPage',
                        cache: false,
                        data: {
                            bookId: $('#pageNumberEntry').attr('data-bookid'),
                            pageNum: pageNumber
                        },
                        dataType: 'json',
                        success: function (response) {
                            if (response.Success) {
                                window.location = response.RedirectURL;
                            }
                            else {
                                $('.pageError').text(response.ErrorMessage).show();
                            }
                        }
                    });
                }
            }
            else {
                // nothing entered
                $('.pageError').text('Please enter a page number').show();
            }
        });
    };

    // On Document.Ready - init
    $(function () {
        ns.init();
        ns.goToPageHandler();

    });

})(SCM.BookToc = SCM.BookToc || {},
    SCM.BookToc.Headings = SCM.BookToc.Headings || {},
    SCM.InstitutionOpenUrl = SCM.InstitutionOpenUrl || {}, jQuery);